var _excluded = ["property"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import AllhomesListingMap from './allhomes-listing-map';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ListingMap on Property {\n    address {\n      formattedFull\n      cadastralParcel {\n        block\n        section\n        legalDescription\n        blockMapImageUrl\n        blockSize\n        unimprovedValue {\n          formatted\n        }\n      }\n      coordinates {\n        lat\n        lon\n        staticMapUrl\n        x\n        y\n      }\n      division {\n        name\n        state {\n          abbrev\n        }\n        centroid {\n          lat\n          lon\n        }\n      }\n    }\n  }\n"])));
var SUPPRESSED_ADDRESS_ZOOM_LEVEL = 13;
var graphQLToProps = function graphQLToProps(_ref) {
  var _address$coordinates, _address$cadastralPar, _address$cadastralPar2, _address$cadastralPar3, _address$cadastralPar4, _address$cadastralPar5, _address$coordinates2, _address$coordinates3, _address$coordinates4, _address$division, _address$division$cen, _address$coordinates5, _address$division2, _address$division2$ce;
  var _ref$mapConfiguration = _ref.mapConfiguration,
    mapConfiguration = _ref$mapConfiguration === void 0 ? {} : _ref$mapConfiguration,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? undefined : _ref$icon;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$address = _ref2.address,
    address = _ref2$address === void 0 ? {} : _ref2$address;
  return {
    state: address.division.state.abbrev,
    fullAddress: address.formattedFull,
    signedMapUrl: "".concat((_address$coordinates = address.coordinates) === null || _address$coordinates === void 0 ? void 0 : _address$coordinates.staticMapUrl),
    blockInfo: {
      imageUrl: (_address$cadastralPar = address.cadastralParcel) === null || _address$cadastralPar === void 0 ? void 0 : _address$cadastralPar.blockMapImageUrl,
      suburb: address.division.name,
      block: (_address$cadastralPar2 = address.cadastralParcel) === null || _address$cadastralPar2 === void 0 ? void 0 : _address$cadastralPar2.block,
      section: (_address$cadastralPar3 = address.cadastralParcel) === null || _address$cadastralPar3 === void 0 ? void 0 : _address$cadastralPar3.section,
      unimprovedValue: address.cadastralParcel && address.cadastralParcel.unimprovedValue && address.cadastralParcel.unimprovedValue.formatted,
      blockSize: (_address$cadastralPar4 = address.cadastralParcel) === null || _address$cadastralPar4 === void 0 ? void 0 : _address$cadastralPar4.blockSize,
      blockSizeApprox: true,
      legalDescription: (_address$cadastralPar5 = address.cadastralParcel) === null || _address$cadastralPar5 === void 0 ? void 0 : _address$cadastralPar5.legalDescription,
      disclaimerText: mapConfiguration.disclaimerText
    },
    landDetailsConfig: {
      center: [(_address$coordinates2 = address.coordinates) === null || _address$coordinates2 === void 0 ? void 0 : _address$coordinates2.x, (_address$coordinates3 = address.coordinates) === null || _address$coordinates3 === void 0 ? void 0 : _address$coordinates3.y],
      listingDescription: address.formattedFull,
      wmsUrl: mapConfiguration.wmsUrl,
      schoolMarkerEndpoint: mapConfiguration.schoolMarkerEndpoint,
      fullMapLink: mapConfiguration.fullMapLink
    },
    listingMapProps: {
      googleMapsParams: {
        key: mapConfiguration.googleMapsKey
      },
      coords: {
        lat: ((_address$coordinates4 = address.coordinates) === null || _address$coordinates4 === void 0 ? void 0 : _address$coordinates4.lat) || ((_address$division = address.division) === null || _address$division === void 0 ? void 0 : (_address$division$cen = _address$division.centroid) === null || _address$division$cen === void 0 ? void 0 : _address$division$cen.lat),
        lng: ((_address$coordinates5 = address.coordinates) === null || _address$coordinates5 === void 0 ? void 0 : _address$coordinates5.lon) || ((_address$division2 = address.division) === null || _address$division2 === void 0 ? void 0 : (_address$division2$ce = _address$division2.centroid) === null || _address$division2$ce === void 0 ? void 0 : _address$division2$ce.lon)
      },
      zoom: address.coordinates ? mapConfiguration.zoom : SUPPRESSED_ADDRESS_ZOOM_LEVEL,
      icon,
      marker: address.coordinates ? 'exact' : 'approximate'
    }
  };
};
var AllhomesListingMapGraphQL = _ref3 => {
  var property = _ref3.property,
    props = _objectWithoutProperties(_ref3, _excluded);
  return ___EmotionJSX(AllhomesListingMap, _extends({}, graphQLToProps(props, property), props));
};
AllhomesListingMapGraphQL.fragment = fragment;
AllhomesListingMapGraphQL.propTypes = {
  property: PropTypes.shape({
    address: PropTypes.shape({
      formattedFull: PropTypes.string,
      cadastralParcel: PropTypes.shape({
        block: PropTypes.string,
        section: PropTypes.string,
        legalDescription: PropTypes.string,
        blockMapImageUrl: PropTypes.string,
        blockSize: PropTypes.number,
        blockSizeApprox: PropTypes.bool,
        unimprovedValue: PropTypes.shape({
          formatted: PropTypes.string
        })
      }),
      coordinates: PropTypes.shape({
        lat: PropTypes.number,
        lon: PropTypes.number,
        staticMapUrl: PropTypes.string,
        x: PropTypes.number,
        y: PropTypes.number
      }),
      division: PropTypes.shape({
        name: PropTypes.string,
        state: PropTypes.shape({
          abbrev: PropTypes.string
        }),
        centroid: PropTypes.shape({
          lat: PropTypes.number,
          lon: PropTypes.number
        })
      })
    })
  })
};
AllhomesListingMapGraphQL.defaultProps = {
  property: {}
};
export default AllhomesListingMapGraphQL;